import './Photo.css';
import self from './res/self.jpg';

function Photo(){
    return (
        <img className="Photo-self" src={self} alt="Picture of Justin"></img>
    );
}

export default Photo;